import { render, staticRenderFns } from "./CustomerScheduleCard.vue?vue&type=template&id=1b5ba535&scoped=true"
import script from "./CustomerScheduleCard.vue?vue&type=script&lang=js"
export * from "./CustomerScheduleCard.vue?vue&type=script&lang=js"
import style0 from "./CustomerScheduleCard.vue?vue&type=style&index=0&id=1b5ba535&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5ba535",
  null
  
)

export default component.exports